
import { actions, types } from './requests'
export const DOASSIGNVARIANTS_TYPES = {
    ...types('DOASSIGNVARIANTS'),
}
export const DOASSIGNVARIANTS_ACTIONS = {
    ...actions('DOASSIGNVARIANTS'),
}